import { planRepository } from "../repositories";

export const planService = {
  async getPlans() {
    return planRepository.findAll();
  },

  async getPlan(id: string) {
    const plan = await planRepository.findById(id);
    if (!plan) throw new Error(`Plan ${id} introuvable`);
    return plan;
  },

  async getPlanByCode(code: string) {
    const plan = await planRepository.findByCode(code);
    if (!plan) throw new Error(`Plan code "${code}" introuvable`);
    return plan;
  },
};
